/* global femcare */

femcare.product.panel.info.slider = {

    init: function() {
        var $slider = $('.product-main__info-panel .suggested-products__slider');

        if($slider.length) {
            new Swiper($slider.find('.swiper-container')[0], {
                lazy: true,
                spaceBetween: 10,
                breakpoints: {
                    400: {
                        slidesPerView: 1.25,
                    },
                    550: {
                        slidesPerView: 1.75,
                    },
                    992: {
                        slidesPerView: 1,
                    },
                    1070: {
                        slidesPerView: 1.25,
                    },
                    1500: {
                        slidesPerView: 2
                    }
                },
                navigation: {
                    nextEl: $slider.find('.suggested-products-slider__next')[0],
                    prevEl: $slider.find('.suggested-products-slider__previous')[0]
                },
            });
        }
    }
}